import { formatDistance, formatDuration } from '../lib/geo';
import { WALK_SPEED_MPS } from '../lib/route';
import { fmtTime } from '../lib/time';
import { useAppStore } from '../state/store';
import { shadeColor } from './colors';
import { IconShade, IconStop, IconWarning } from './Icons';
import { ShadeTimeline } from './ShadeTimeline';

const ARRIVED_M = 25;

/** Pannello di navigazione: quanto manca, ombra davanti, fuori percorso. */
export function NavigationHUD() {
  const plan = useAppStore((s) => s.plan);
  const navFix = useAppStore((s) => s.navFix);
  const userPos = useAppStore((s) => s.userPos);
  const stopNav = useAppStore((s) => s.stopNav);
  const setPoint = useAppStore((s) => s.setPoint);

  if (!plan) return null;
  const { chosen } = plan;
  const remainingM = navFix ? navFix.remainingM : chosen.lengthM;
  const remainingS = remainingM / WALK_SPEED_MPS;
  const etaMs = Date.now() + remainingS * 1000;
  const shadeAhead = navFix ? navFix.remainingShadeFrac : chosen.shadeFrac;
  const arrived = navFix !== null && navFix.remainingM < ARRIVED_M && !navFix.offRoute;

  const recalcFromHere = () => {
    if (!userPos) return;
    setPoint('a', userPos.ll, 'La mia posizione');
  };

  return (
    <section className="nav" aria-label="Navigazione">
      <div data-peek>
        <div className="nav__head">
          <div className="grow">
            {arrived ? (
              <div className="nav__dist">Sei arrivato 🎉</div>
            ) : (
              <>
                <div className="nav__dist t-num">{formatDistance(remainingM)}</div>
                <div className="nav__eta t-sub t-num">
                  {formatDuration(remainingS)} · arrivo {fmtTime(etaMs)}
                </div>
              </>
            )}
            <span className="nav__shade" style={{ color: shadeColor(shadeAhead) }}>
              <IconShade size={14} /> {Math.round(shadeAhead * 100)}% di ombra davanti a te
            </span>
          </div>
          <button type="button" className="btn btn--danger btn--sm nav__stop" onClick={stopNav}>
            <IconStop size={15} /> Esci
          </button>
        </div>

        <ShadeTimeline segments={chosen.segments} progress={navFix?.progress ?? 0} compact />

        {!userPos && (
          <p className="nav__gps">
            <span className="mini-spinner" /> Cerco il segnale GPS…
          </p>
        )}
        {userPos && navFix?.offRoute && (
          <div className="callout callout--warn nav__off">
            <span className="callout__icon">
              <IconWarning size={18} />
            </span>
            <div className="grow">
              <p>Sei a {formatDistance(navFix.distToRouteM)} dal percorso.</p>
              <button type="button" className="btn btn--xs btn--tinted" onClick={recalcFromHere}>
                Ricalcola da qui
              </button>
            </div>
          </div>
        )}
      </div>

      {userPos && !navFix?.offRoute && !arrived && (
        <p className="t-cap nav__hint">
          Precisione GPS {Math.round(userPos.accuracyM)} m · trascina la mappa per esplorare, il
          bottone di posizione ricentra.
        </p>
      )}
    </section>
  );
}
